import { createSelector } from 'reselect';

const getHelp = (state) => state.help || {};

export const selectHelpTabIndex = createSelector(
  getHelp,
  ({ tabIndex }) => tabIndex
);

export const selectHelpFetching = createSelector(
  getHelp,
  ({ fetching }) => fetching
);

export const selectOrderFetching = createSelector(
  getHelp,
  ({ orderFetching }) => orderFetching
);

export const selectHelpListFetching = createSelector(
  getHelp,
  ({ listFetching }) => listFetching
);

export const selectHelpCategories = createSelector(
  getHelp,
  ({ categories }) => categories
);

export const selectHelpNewsList = createSelector(
  getHelp,
  ({ newsList }) => newsList
);

export const selectHelpHelpItems = createSelector(
  getHelp,
  ({ helpItems }) => helpItems
);

export const selectHelpHelpItemId = createSelector(
  getHelp,
  ({ itemId }) => itemId
);

export const selectHelpMainItems = createSelector(
  getHelp,
  ({ mainItems }) => mainItems
);

export const selectHelpLangList = createSelector(
  getHelp,
  ({ langList }) => langList
);

export const selectHelpItemsDetails = createSelector(
  getHelp,
  ({ helpItemsDetails }) => helpItemsDetails
);
